import { Modal, secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledModal = styled(Modal).attrs({
  maxWidth: '80rem',
  padding: '0',
})``;

export const StyledContent = styled.div<{ isPremium: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 38.5rem;
  padding: 3rem 1.8rem ${({ isPremium }) => (isPremium ? '28rem' : '23.4rem')};
  position: relative;
  overflow: hidden;
  background: ${secondaryColors.offBlack};
  z-index: 0;

  @media screen and (min-width: 576px) {
    padding: 4.6rem;
    align-items: flex-start;
  }

  & > div {
    z-index: 10;
  }
`;

export const StyledHeading = styled.div`
  max-width: 36rem;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 48rem;
  }
`;

export const StyledTitle = styled.h2`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 2.4rem;
  margin-bottom: 0rem;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  }

  @media screen and (min-width: 576px) {
    text-align: left;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 3.2rem;
    sup {
      font-size: 2.4rem;
    }
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: 2.4rem;
  line-height: 3rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
  text-align: center;
  margin-bottom: 0rem;
  margin-top: 1.6rem;
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (min-width: 576px) {
    text-align: left;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  }
`;

export const StyledText = styled.div`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
  padding-top: 1.6rem;
`;

export const StyledCountdownContainer = styled.div`
  padding: 2.4rem 0rem 1.6rem;
`;

const Gradient = styled.div`
  background: radial-gradient(50% 50% at 50% 50%, rgba(11, 86, 63, 1) 0%, rgba(21, 28, 43, 0.00) 100%);
  width: 87rem;
  height: 40rem;
  border-radius: 87px;
  z-index: 2;
`;

export const TopGradient = styled(Gradient)`
  position: absolute;
  left: -46.4rem;
  top: -9.4rem;
`;

export const BottomGradient = styled(Gradient)`
  position: absolute;
  right: -34.6rem;
  bottom: -22.1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    background: none;
  }
`;
